import React from 'react';
import './ProgressMeterTutor.scss';
const dividerColorChange = [5, 15, 25, 35, 46, 56, 66, 76, 87, 97];

function ProgressMeterTutor(props) {
	const { width, height, mileStoneData, data, isQualified } = props;
	let progressBartutorMargin = isQualified ? { 'margin-top': '60px' } : {};
	return (
		<div className="progressBartutorContainer" style={progressBartutorMargin} > 
			
			<div className="progressBartutorContainer__ProgressBartutor"
			style={{  height: `${height}px` }}
			 >
			
				<span
					className="progressBartutorContainer__ProgressBartutor__Indicator"
					style={{ width: `${width}%`, height: `${height}px` }}
					
				>
					<span className="progressBartutorContainer__ProgressBartutor__Indicator--Fill"
					>
					
					</span>
				</span>
				{/* { !isQualified&&<><div className="progressBarContainer__qualifierBar"/>
      <img src={QualifierFlagIcon} className="progressBarContainer__qualifierIcon"/></>} */}
			</div>
			{/* <div className="progressBarContainer__progressBarDividersContainer"> */}
			{/* <><div className="progressBarContainer__progressBarDividersContainer__completion">
          {data?.completedPercent}
        </div>
          <div className="progressBarContainer__progressBarDividersContainer__goal">
            Goal:{' '} {data?.goal}
          </div></> */}
			{
				<div className="progressBartutorContainer__progressBartutorDividersContainer__row">
					{mileStoneData?.map((milestone, index) => (
						<ProgressBartutorDividers
							key={index}
							index={index}
							amount={milestone?.text}
							bgColor={milestone?.bgColor}
							textColor={milestone?.textColor}
							width={width}
						/>
					))}
				</div>
			}
			{/* </div> */}
		</div>
	);
}

const ProgressBartutorDividers = ({
	index,
	amount,
	bgColor,
	textColor,
	width = 0,
}) => {
	return (
		<div
			className="progressBartutorDividers"
			style={{ marginTop: index % 2 !== 0 ? '19.5px' : '-18px' }}
		>
			{index % 2 === 0 && (
				<div
					className="progressBartutorDividers__priceEmblem progressBartutorDividers__priceEmblem--top"
					style={{
						'background': bgColor,
						'color': textColor,
						'--databgColor': bgColor,
						'marginBottom': '11px',
					}}
				>
					{amount}
				</div>
			)}
			<div
				className="progressBartutorDividers__progressBartutorDividerLines"
				style={{
					background:
						width >= dividerColorChange[index] ? '#FFFFFF' : '#CFCFCF',
				}}
			></div>
			{index % 2 !== 0 && (
				<div
					className="progressBartutorDividers__priceEmblem progressBartutorDividers__priceEmblem--bottom"
					style={{
						'background': bgColor,
						'color': textColor,
						'--databgColor': bgColor,
						'marginTop': '11px',
					}}
				>
					{amount}
				</div>
			)}
		</div>
	);
};

export default ProgressMeterTutor;
